export default __webpack_public_path__ + "media/images/images_v2/fleche-bas-f33dfbae224142aec61de636e9d2e769.png";